// extracted by mini-css-extract-plugin
export default {"wrapper":"spacing-module--wrapper--1a1d2","compact":"spacing-module--compact--23b54","expanded":"spacing-module--expanded--887fd"};